
export default {
  props: {
    sortItems: {
      type: Array,
      required: true,
    },

    title: {
      type: String,
      default: 'Sortieren nach',
    },
  },

  data() {
    return {
      innerValue: '',
    }
  },

  mounted() {
    if (this.sortItems.length > 0) {
      this.innerValue = this.sortItems[0]
    }
  },
}
